import { Star, Award, Users, Clock, Shield, ThumbsUp } from "lucide-react";
import { motion } from "framer-motion";

const reasons = [
  { icon: Star, title: "Doświadczenie", description: "Ponad 999 występów dla największych firm w Polsce", stat: "999+" },
  { icon: Award, title: "Profesjonalizm", description: "Zawodowi komicy z wieloletnim stażem scenicznym", stat: "27 lat+" },
  { icon: Users, title: "Dostosowanie", description: "Program dopasowany do charakteru Twojej firmy", stat: "100%" },
  { icon: Clock, title: "Punktualność", description: "Zawsze na czas, zawsze przygotowani", stat: "24/7" },
  { icon: Shield, title: "Gwarancja", description: "Gwarantujemy zadowolenie lub zwrot pieniędzy", stat: "100%" },
  { icon: ThumbsUp, title: "Rekomendacje", description: "Setki pozytywnych opinii od zadowolonych klientów", stat: "100%" },
];

export const WhyUs = () => {
  return (
    <section id="why-us" className="py-24 bg-secondary/50 relative">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-accent font-semibold text-sm tracking-widest uppercase">Zaufaj nam</span>
          <h2 className="text-4xl md:text-5xl font-montserrat font-bold mt-3 text-primary">
            Dlaczego my?
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {reasons.map((reason, i) => {
            const Icon = reason.icon;
            return (
              <motion.div
                key={reason.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.08 * i }}
                className="p-8 rounded-2xl bg-white hover:shadow-xl transition-all duration-500 group"
              >
                <div className="flex items-start justify-between mb-5">
                  <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center group-hover:bg-accent/20 transition-colors">
                    <Icon className="w-6 h-6 text-accent" />
                  </div>
                  <span className="text-3xl font-montserrat font-black text-primary/10 group-hover:text-accent/20 transition-colors">
                    {reason.stat}
                  </span>
                </div>
                <h3 className="text-xl font-montserrat font-bold mb-2 text-primary">{reason.title}</h3>
                <p className="text-gray-500 leading-relaxed">{reason.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
